/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Area_MaxInputs */

const cs_filter_area_max = /** @type {(inputs: Filter_Area_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha do (m²)`)
};

const en_filter_area_max = /** @type {(inputs: Filter_Area_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area to (m²)`)
};

/**
* | output |
* | --- |
* | "Area to (m²)" |
*
* @param {Filter_Area_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_area_max = /** @type {((inputs?: Filter_Area_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Area_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_area_max(inputs)
	return cs_filter_area_max(inputs)
});